import React from "react";
import { Layout, Avatar, Dropdown, Menu, Modal } from "antd";
import FontIcon from "../components/YhIcon";
import useGlobalModel from "../model/globalModel";
import useNavModel from "../model/navModel";
import Logo from "@assets/images/header-logo.png"
import Logo1 from "@assets/images/header-logo1.png"
import { loginService } from "@src/views/login/LoginService";
import { clearToken } from "@src/utils/constants";
import { logService } from "@src/views/authPortal/log/LogService";
import { UserOutlined } from "@ant-design/icons";

const { Header } = Layout;

function FmsHeader() {
    const { user, setUser, initUserState, setChangePassVisible } = useGlobalModel();
    const { initNav, clearNav } = useNavModel();
    const REACT_APP_ENV = process.env.REACT_APP_ENV as "DEV" | "TEST" | "PROD" | "STAGE";
    //退出登录
    const onLogout = async () => {
        try {
            await logService.appLogout(user.userCode as string)
            await loginService.userLogout()
        } catch (error) {
            console.error("退出异常:", error)
        } finally {
            setUser(initUserState)
            clearToken()
            clearNav()
        }
    };
    // 菜单项
    const HeaderMenu = () => {
        const onClearCache = () => {
            initNav()
        }
        return (
            <Menu>
                <Menu.Item key="0">
                    <span onClick={onClearCache}>关闭所有标签</span>
                </Menu.Item>
                {/* <Menu.Divider /> */}
            </Menu>
        )
    }
    return (
        <Header className="layout-section-header">
            {/* 左侧按钮 */}
            <div className="header-left flex items-center">
                <div className="layout-sider-logo">
                    <img className="layout-sider-logo-img" src={REACT_APP_ENV == "PROD" ? Logo1 : Logo} alt="财务管理系统Logo" />
                    <span className="one-line">门户系统</span>
                </div>
                <div className="layout-sider-portal flex items-center">
                    {/* <div className="flex-column portal-item ">
                        <FontIcon type="icon-zongjituan" className="portal-icon" />
                        <span>集团门户</span>
                    </div> */}
                    <div className="flex-column portal-item" data-active={true}>
                        <FontIcon type="icon-gerenzhongxin-zhong1" className="portal-icon" />
                        <span>个人门户</span>
                    </div>
                    {/* <div className="flex-column portal-item" >
                        <FontIcon type="icon-zuhe" className="portal-icon" />
                        <span>管理门户</span>
                    </div> */}
                </div>
            </div>
            {/* 右侧内容 */}
            <div className="header-right" style={{ paddingRight: "15px" }}>

                {/* 设置 */}
                <Dropdown overlay={HeaderMenu} placement="bottomCenter" trigger={['click']}>
                    <Avatar className="header-right-item config-icon" icon={<FontIcon type="icon-shezhi" />} />
                </Dropdown>

                {/* 登录用户信息 */}
                <Dropdown overlay={() => (
                    <Menu>
                        <Menu.Item key="0">
                            <span onClick={() => { setChangePassVisible(true) }}>修改密码</span>
                        </Menu.Item>
                        {/* <Menu.Divider /> */}
                    </Menu>
                )} placement="bottomCenter" trigger={['click']}>
                    <span onClick={e => e.preventDefault()} className="flex items-center header-right-item user-info ">
                        <Avatar
                            size="default"
                            icon={<UserOutlined />}
                            className="user-icon"
                        />
                        <span className="account">{user.userName ?? "未获取到"}</span>
                    </span>
                </Dropdown>

                {/* 退出登录 */}
                <FontIcon type="icon-tuichu" className="header-right-item logout-icon" onClick={user.loginType === 'account' ? onLogout : () => { }} />
            </div>
        </Header>
    )
}

export default FmsHeader;